import { Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import "../assets/styles/layers.scss";
import EditIcon from "../assets/images/edit_rgb_dark_green.svg";
import InformationLayerMap from "../components/InformationLayerMap";
import UpdateLayerForms from "../components/Layers/Update/UpdateLayerForms";
import MapInstruction from "../components/Layers/MapInstruction";
import api from "../services/httpClient";

const LayerUpdate = () => {
  const { layerId } = useParams();
  const [layerData, setLayerData] = useState(null);
  const [currentArea, setCurrentArea] = useState(null);
  const [selectedColor, setSelectedColor] = useState("#000000");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLayerData = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/Layer/${layerId}`);
        setLayerData(response.data);
        setCurrentArea(response.data?.area);
  setSelectedColor(response.data?.color || "#000000");
        setError(null);
      } catch (err) {
        console.error("Error fetching layer data:", err);
        setError("Nie udało się pobrać danych warstwy.");
      } finally {
        setLoading(false);
      }
    };

    if (layerId) {
      fetchLayerData();
    }
  }, [layerId]);

  const handleAreaUpdate = (newArea) => {
    setCurrentArea(newArea);
  };

  if (loading) {
    return <div className="layers-container">Ładowanie...</div>;
  }

  if (error) {
    return <div className="layers-container">{error}</div>;
  }
  
  return (
    <div className="layers-container">
      <Container fluid>
        <Row className="align-items-center mb-4">
          <Col>
            <div className="d-flex align-items-center">
              <img
                src={EditIcon}
                alt="Edit Icon"
                style={{ width: "30px", height: "30px", marginRight: "12px" }}
              />
              <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", margin: 0 }}>
                Edycja warstwy
              </h3>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4}>
          <Row>
            <UpdateLayerForms 
              name={layerData?.name} 
              color={selectedColor}
              onColorChange={setSelectedColor}
              area={currentArea}
            />
          </Row>
            <Row>
              <MapInstruction
                containerProps={{ fluid: true, className: "my-3" }}
                variant="light" 
                bordered
              />
            </Row>
          </Col>
          <Col xs={12} md={8}>
            <InformationLayerMap 
              area={currentArea} 
              color={selectedColor}
              onAreaUpdate={handleAreaUpdate}
              editable={true}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LayerUpdate;
